import React from "react";
import { Label } from "@/components/ui/label";
const stats = [{
  value: "500+",
  label: "Zadowolonych rodzin"
}, {
  value: "15+",
  label: "Lat doświadczenia"
}, {
  value: "1200+",
  label: "Wypłukanych grzejników"
}, {
  value: "-25%",
  label: "Koszty ogrzewania"
}];
export default function NumbersAndFacts() {
  return <section data-section-id="131891" id="nasze-osiągnięcia-w-liczbach" className="dark bg-background text-foreground py-20 md:py-32 relative overflow-hidden border-y border-border/40">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:3rem_3rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_40%,transparent_100%)] opacity-20 pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8 text-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center space-y-4 group">
              <span className="text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter text-transparent [-webkit-text-stroke:2px_var(--color-primary)] transition-all duration-500 group-hover:[-webkit-text-stroke:2px_var(--color-foreground)] group-hover:drop-shadow-[0_0_30px_var(--color-primary)]">
                {stat.value}
              </span>
              <Label className="font-mono text-xs md:text-sm text-muted-foreground uppercase tracking-widest">
                {stat.label}
              </Label>
            </div>)}
        </div>
      </div>
    </section>;
}